// `TimeWindow` — `{ days[], start, end }` (spec/08-api-design.md §3, spec/06 §4).
//
// When a rate, a pass or an offer applies: happy hour, weekend nights, holidays. `start` and `end`
// are times of day in the venue's timezone, and a window may cross midnight (`22:00`–`02:00`), so
// `end` before `start` is legal and means "until that time tomorrow".
import { z } from "../zod.js";
import { LocalTimeSchema, TimeWindowDaySchema } from "./scalars.js";
export const TimeWindowSchema = z
    .object({
    /** The days the window covers. Empty is not allowed; a window with no day never fires. */
    days: z.array(TimeWindowDaySchema).min(1).max(8),
    start: LocalTimeSchema,
    end: LocalTimeSchema,
})
    .openapi('TimeWindow', {
    description: "A recurring time of day in the venue's timezone. `end` earlier than `start` means the window crosses midnight.",
});
//# sourceMappingURL=time-window.js.map